module.exports = __webpack_public_path__ + "img/nexo.228edf93.png";